import Chart from 'src/componentes/chart';
import { getOptionColor, toNumber } from './utils';

const PIE_CHART_CLASS_NAME =
  'tw:relative tw:h-55 tw:min-w-0 tw:w-full tw:max-[900px]:max-w-65 tw:max-[900px]:justify-self-center';

function GraficoPizzaOpcoes({ intl, opcoes, titulo }) {
  const totalRespostas = opcoes.reduce(
    (total, opcao) => total + toNumber(opcao.quantidade),
    0
  );

  if (totalRespostas === 0) {
    return (
      <div
        className={`${PIE_CHART_CLASS_NAME} tw:flex tw:items-center tw:justify-center tw:text-center tw:text-xs tw:text-[#98a2b3]`}
      >
        {intl.formatMessage({ id: 'labelNenhumaRespostaParaExibir' })}
      </div>
    );
  }

  const data = opcoes.map((opcao, index) => {
    const quantidade = toNumber(opcao.quantidade);
    const percentual = intl.formatNumber(toNumber(opcao.percentual), {
      maximumFractionDigits: 2,
    });

    return {
      color: getOptionColor(opcao, index),
      label: opcao.texto,
      toolText: `${
        opcao.texto
      }: ${percentual}% · ${quantidade} ${intl.formatMessage({
        id: 'labelRespostas',
      })}`,
      value: quantidade,
    };
  });

  return (
    <div aria-label={titulo} className={PIE_CHART_CLASS_NAME} role="img">
      <Chart
        containerBackgroundOpacity="0"
        dataFormat="json"
        dataSource={{
          chart: {
            animation: '0',
            bgAlpha: '0',
            canvasBgAlpha: '0',
            captionPadding: '0',
            chartBottomMargin: '0',
            chartLeftMargin: '0',
            chartRightMargin: '0',
            chartTopMargin: '0',
            enableMultiSlicing: '0',
            legendBgAlpha: '0',
            plotBorderColor: '#ffffff',
            plotBorderThickness: '2',
            showBorder: '0',
            showLabels: '0',
            showLegend: '0',
            showPlotBorder: '1',
            showValues: '0',
            theme: 'fusion',
            use3DLighting: '0',
          },
          data,
        }}
        height="220"
        type="pie2d"
        width="100%"
      />
    </div>
  );
}

export default GraficoPizzaOpcoes;
